export const callTransaction = (contract: any, method: string, args: any, overrides: any = null) => {
  try {
    return contract[method](...args, { ...overrides });
  } catch (error: any) {
    return error.message;
  }
};
